<div [hidden]="!viewNotification" style="position: absolute; top: 10%; left: 0; width: 310px; z-index: 9999"></div>
<nav class="navbar navbar-v4 bg-body-tertiary align-items-end">
  <div class="container-fluid mob-flex-v4">
    <div class="navbar-brand d-flex align-items-center" href="#">
      <img src="/assets/img/logo/login-logo.png" alt="Knowledge Gate" />
    </div>
    <div class="{{!isLogin ? 'mx-3 d-flex justify-content-between' :'mx-3 mobile-d-none d-flex justify-content-between'}}" style="flex: 1 1 auto">
      <div class="nav-flex-v4" [hidden]="externalCoordinator?.status == true" [routerLink]="'/home'">
        <div class="d-flex align-items-center justify-content-center">
          <i class="pi pi-fw pi-home icone-v4"></i>
        </div>
        <div>
          <a class="nav-links-v4">
            {{ "Homepage" | translator }}
          </a>
        </div>
      </div>
      <div *ngIf="isLogin" class="nav-flex-v4" [routerLink]="'/password-change'">
        <div class="d-flex align-items-center justify-content-center">
          <i class="pi pi-fw pi-key icone-v4"></i>
        </div>
        <div>
          <a class="nav-links-v4">
            {{ "Password Reset" | translator }}</a>
        </div>
      </div>

      <div *ngIf="isLogin" class="nav-flex-v4" [hidden]="externalCoordinator?.status == true"
        [routerLink]="'/user-profile'">
        <div class="d-flex align-items-center justify-content-center">
          <i class="pi pi-fw pi-user icone-v4"></i>
        </div>
        <div>
          <a class="nav-links-v4">
            {{ "Profile personly" | translator }}
          </a>
        </div>
      </div>
      <div *ngIf="hasPermission('KNOWLEDGE_LIBRARY','r') || (!isLogin && hasOpenLibraryPermission())"
        class="nav-flex-v4" [hidden]="externalCoordinator?.status == true" [routerLink]="'/knowledge-library'">
        <div class="d-flex align-items-center justify-content-center">
          <i class="pi pi-fw pi-book icone-v4"></i>
        </div>
        <div>
          <a class="nav-links-v4">{{ "Knowledge Library" | translator }}
          </a>
        </div>
      </div>

      <div *ngIf="hasPermission('CONTENT','r') || (!isLogin && hasOpenViewPermission())" class="nav-flex-v4" [hidden]="externalCoordinator?.status == true"
        [routerLink]="'/all-data-view'">
        <div class="d-flex align-items-center justify-content-center">
          <i class="pi pi-fw pi-list icone-v4"></i>
        </div>
        <div>
          <a class="nav-links-v4">{{ "Navigation page" | translator }}
          </a>
        </div>
      </div>

      <div *ngIf="externalCoordinator.status != true && isLogin" class="nav-flex-v4" (click)="navigateToFav()">
        <div class="d-flex align-items-center justify-content-center">
          <i class="fa-regular fa-star icone-v4"></i>
        </div>
        <div>
          <a class="nav-links-v4">{{ "Favorite" | translator }}
          </a>
        </div>
      </div>

      <div *ngIf="isLogin" class="nav-flex-v4" (click)="handleLogout()">
        <div class="d-flex align-items-center justify-content-center">
          <i class="pi pi-fw pi-sign-out icone-v4"></i>
        </div>
        <div>
          <a class="nav-links-v4">
            {{ "Log out" | translator }}
          </a>
        </div>
      </div>

      <div *ngIf="!isLogin" class="nav-flex-v4" (click)="handleLogout()">
        <div class="d-flex align-items-center justify-content-center">
          <i class="pi pi-fw pi-sign-in icone-v4"></i>
        </div>
        <div>
          <a class="nav-links-v4">
            {{ "Login" | translator }}
          </a>
        </div>
      </div>

      <!-- <div *ngIf="externalCoordinator.status != true && isLogin" class="d-flex justify-content-center">
        <button (click)="navigateToFav()" class="btn color-white mx-2 font-0_8rem">
          <i *ngIf="getFavoriteCount() != '0'; else iconTemplate" class="fa-regular fa-star text-3xl star-size redd" pBadge
            severity="danger" [value]="getFavoriteCount()"></i>
          <ng-template #iconTemplate>
            <div class="pos-rel">
              <i class="fa-regular fa-star text-3xl star-size "></i>
            </div>
          </ng-template>
        </button>
      </div> -->


      <div *ngIf="externalCoordinator.status != true && isLogin" class="d-flex justify-content-center">
        <button (click)="viewNotification = !viewNotification" class="btn color-white mx-2 font-0_8rem">
          <i *ngIf="newNotificationCount > 0; else iconTemplate" class="pi pi-bell text-3xl bell-size redd" pBadge
            severity="danger" [value]="newNotificationCount.toString()"></i>
          <ng-template #iconTemplate>
            <div class="pos-rel">
              <i class="pi pi-bell text-3xl bell-size "></i>
            </div>
          </ng-template>
        </button>
      </div>
    </div>
    <app-sidenav [hidden]="externalCoordinator?.status == true || !isLogin"></app-sidenav>
  </div>
</nav>

<!-- <hr class="hr border-white" /> -->

<p-sidebar class="v4-left-p-sidebar" [(visible)]="viewNotification">
  <ng-template pTemplate="header">
    <span class="d-flex w-100">
      <img class="not-img" src="../../../assets/icons/SBC/speaker-vedios.svg" alt="loading" />
      <span class="not-head mx-2"> {{ "Notifications" | translator }}</span>
    </span>
  </ng-template>
  <ng-template pTemplate="content" class="p-0" style="padding: 0px">
    <div class="notify-scroll">
      <!-- <span class="clone-times" (click)="viewNotification = false;"><i class="pi pi-times"></i></span> -->
      <div class="notification">
        <div *ngFor="let notification of notifications" role="button" (click)="markSeen(notification)" class="d-flex align-items-center {{
            isSeen(notification)
              ? 'notification-box'
              : 'notification-box-active'
          }}">
          <div>
            <img *ngIf="checkIsImage(notification.image); else elseBlock" class="notification-img"
              src="{{ staticFileUrl + notification.image }}" onerror="this.src='../../../assets/person-placeholder.jpg'"
              alt="loading" />
            <ng-template #elseBlock>
              <div class="notification-img d-center">
                <i class="{{ notification.image }}" style="font-size: 2rem"></i>
              </div>
            </ng-template>
          </div>
          <div class="column">
            <span class="{{
                isSeen(notification)
                  ? 'notification-label'
                  : 'notification-label-active'
              }}">{{ notification.title }}</span>
            <span class="{{
                isSeen(notification)
                  ? 'notification-label-deactive'
                  : 'notification-label-active'
              }}" style="font-weight: 500; font-size: 12px">{{ notification.name }}</span>
            <span class="{{
                isSeen(notification)
                  ? 'notification-text'
                  : 'notification-text-active'
              }}">{{ notification.message }}</span>
            <span class="{{
                isSeen(notification)
                  ? 'notification-date'
                  : 'notification-date-active'
              }}">{{ getDateDifference(notification.createdAt) }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div *ngIf="hasPermission('VIEW_NOTIFICATIONS', 'a')"
      class="w-100 v4-bg-bottom p-2 d-flex align-items-center justify-content-center">
      <button class="w-100 v4-left-nav-btn" routerLink="/notification">
        {{ "showAll" | translator }}
      </button>
    </div>
  </ng-template>
</p-sidebar>